import {detailServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = detailServicesPath + '/organizations/detail-patterns'

export default class PatternsController {
    static async getById(moduleId, id) {
        return axios.get(restUrl + "/" + id + "?moduleId=" + moduleId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async update(data, moduleId, id) {
        return await axios.put(restUrl + '/' + id + "?moduleId=" + moduleId, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(moduleId, data) {
        return await axios.post(restUrl + "?moduleId=" + moduleId, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(moduleId, id) {
        await axios.delete(restUrl + '/' + id + "?moduleId=" + moduleId);
    }
    static async deleteDetail(moduleId, id,detailId) {
        await axios.delete(restUrl + '/' + id + "?moduleId=" + moduleId+"&detailId="+detailId+"/detail");
    }

    static async addDetail(moduleId, id, detailId) {
        return await axios.patch(restUrl + '/' + id + "?moduleId=" + moduleId + "&detailId=" + detailId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}